module.exports = __webpack_public_path__ + "img/edit_icon.f78c5a44.svg";